import { render } from "./PensionPage.vue?vue&type=template&id=5eaf2fc3&scoped=true"
import script from "./PensionPage.vue?vue&type=script&lang=js"
export * from "./PensionPage.vue?vue&type=script&lang=js"

import "./PensionPage.vue?vue&type=style&index=0&id=5eaf2fc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eaf2fc3"]])

export default __exports__